import script from "./NerResult.vue?vue&type=script&setup=true&lang=js"
export * from "./NerResult.vue?vue&type=script&setup=true&lang=js"

import "./NerResult.vue?vue&type=style&index=0&id=49552eba&lang=scss"

const __exports__ = script;

export default __exports__